import { render, staticRenderFns } from "./RuleCriteriaAutocomplete.vue?vue&type=template&id=04a57c84&scoped=true"
import script from "./RuleCriteriaAutocomplete.vue?vue&type=script&lang=js"
export * from "./RuleCriteriaAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./RuleCriteriaAutocomplete.vue?vue&type=style&index=0&id=04a57c84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a57c84",
  null
  
)

export default component.exports